import styled, { css } from 'styled-components'
import AppButton from 'Components/AppButton'
import { OUTLINE_COLOR, CLICKABLE_COLOR, HYPER_LINK_COLOR } from '@CSSVars/colors'
import { BREAK_POINT_SM, BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'

import Signup from './Signup'


export const _LoginModal = styled.div`
  display: ${({ hidden }) => (hidden ? 'none' : 'block')};
  left: 0;
  ${({ listingCard }) => (
    listingCard ?
      `
        background-color: white;
        border-radius: 10px;
        input {
          border: 1px solid ${OUTLINE_COLOR};
        }

        @media screen and (max-width: ${BREAK_POINT_MD}) {
          width: auto;
          height: auto;
        }
      ` : ''
  )};
`


export const _SignupWrap = styled.div.attrs({
  className: 'signupForm',
})`
  width: 760px;
  display: flex;
  justify-content: center;

  > div {
    &:first-child {
      flex-grow: 1;
      flex-basis: 0;
    }
  }

  ${({ listingCard }) => (
    listingCard ?
      `
        width: auto;
        min-width: 320px;
        max-height: 420px;
      ` : ''
  )};

  ${({ loginPage }) => (
    loginPage ?
      `
        width: 310px;
      ` : ''
  )};

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    flex-direction: column-reverse;

    > div {
      &:first-child {
        width: 100%;
        flex-grow: 0;
      }
    }
  }

  @media screen and (max-width: ${BREAK_POINT_SM}) {
      &:first-child {
        flex-direction: column-reverse;
      }
    }
`

const formContMixin = css`
  padding: 56px 28px 64px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    padding: 42px 16px;
  }
`

export const _SignupForm = styled(Signup).attrs({
  className: 'signupForm',
})`
  ${formContMixin};
  flex-shrink: 0;
  border-radius: 10px;
  ${({ loginPage }) => (
    loginPage ?
      `
        width: 310px;
        padding: 0;
      ` : ''
  )}

  ${({ listingCard }) => (
    listingCard ?
      `
        padding: 18px;
        @media screen and (max-width: ${BREAK_POINT_LG}) {
          padding: 24px;
        }

        @media screen and (max-width: ${BREAK_POINT_MD}) {
          padding: 16px;
        }
      ` : ''
  )};

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-shrink: 1;
  }
`

export const _LoginForm = styled.div.attrs({
  className: 'loginForm',
})`
  ${formContMixin};
  min-width: 460px;

  ${({ loginPage }) => (
    loginPage ?
      `
        width: 100%;
        min-width: initial;
        padding: 0;
      ` : ''
  )};
  @media screen and (min-width: ${BREAK_POINT_SM}) {
  }
  @media screen and (max-width: 480px) {
    min-width: initial;
  }
`

export const _SwitchToSignup = styled.button`
  display: block;
  margin: 24px auto 0;
  background-color: transparent;
  border: none;
  text-decoration: underline;
  color: ${CLICKABLE_COLOR};
  cursor: pointer;
  &:focus {
    color: ${HYPER_LINK_COLOR};
  }
`

export const _BiometricsModal = styled.div`
  width: 100%;
  min-height: 165px;
  height: fit-content;
  position: fixed;
  border-radius: 20px 20px 0px 0px;
  background: white;
  opacity: 0;
  transform: translateY(100%);
  transition: opacity 0.5s ease, transform 0.5s ease;
  bottom: 0;
  left: 0;
  right:0;
  z-index: 10000;
  padding: 24px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  &.slide-up {
  transform: translateY(0);
  transition: transform 0.3s ease;
  opacity: 1;
}

  display: flex;
  flex-direction: column;
  gap: 12px;
  div {
      display: flex;
      flex-direction: row;
      width: 100%;
      justify-content: space-between;
  }

`

export const _BiometricsText = styled.div`
    font-size: 14px;
    line-height: 22px;

`

export const _BiometricsBtn = styled(AppButton)`
  height: 44px;
  width: 45%;

`

